import Arc from "./Arc";

export default class ArcCache {
    /**
     * @param {number} cacheSize 
     */
    constructor(cacheSize) {
        /**
         * @type {number}
         */
        this.nextIndex = 0;

        /**
         * @type {Array.<Arc>}
         */
        this.arcs = new Array(cacheSize);
        for (let i = 0; i < cacheSize; i++) {
            this.arcs[i] = new Arc(0, 0);
        }
    }

    resetCache() {
        this.nextIndex = 0;
    }

    /**
     * @param {number} a0 
     * @param {number} a1 
     * @returns {Arc}
     */
    getArc(a0, a1) {
        let arc;
        if (this.nextIndex >= this.arcs.length) {
            arc = new Arc(a0, a1);
            this.arcs.push(arc);
        }
        else {
            arc = this.arcs[this.nextIndex];
            arc.a0 = a0;
            arc.a1 = a1;
        }

        this.nextIndex++;

        return arc;
    }
}